import { render } from "./ResourceResultRow.vue?vue&type=template&id=b94a1110&scoped=true"
import script from "./ResourceResultRow.vue?vue&type=script&lang=ts"
export * from "./ResourceResultRow.vue?vue&type=script&lang=ts"

import "./ResourceResultRow.vue?vue&type=style&index=0&id=b94a1110&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b94a1110"

export default script